import React from 'react';
import styles from './GlobalHeader.module.scss';

interface HeaderProps {
  globalHeaderHtml: string;
}

export const GlobalHeader: React.FunctionComponent<HeaderProps> = ({
  globalHeaderHtml,
}) => {
  return (
    <div
      className={styles.globalHeader}
      dangerouslySetInnerHTML={{ __html: globalHeaderHtml }}
    />
  );
};
